import { SCREEN } from "helper/roleChecker/Screens";

const basePath = "/portal-attend/attend";

export const getTimeCheckingUrl = (screenCode: string) =>
  `${basePath}/${screenCode}/time-keeping`;

export const getListArriveLateUrl = (screenCode: string) =>
  `${basePath}/${screenCode}/arrive-late`;

export const getListArriveLateDetailUrl = (screenCode: string, id: string) =>
  `${basePath}/${screenCode}/arrive-late/${id}`;

export const getListRequestLeaveUrl = (screenCode: string) =>
  `${basePath}/${screenCode}/register-leave`;

export const getListArriveLateManagerUrl = (screenCode: string) =>
  `${basePath}/${screenCode}/manage/arrive-late`;

export const getListRequestLeaveManagerUrl = (screenCode: string) =>
  `${basePath}/${screenCode}/manage/register-leave`;

export const getRequestLeaveDetailUrl = (id: string) =>
  `${basePath}/${SCREEN.IP_016}/register-leave/${id}`;

export const getHolidayUrl = (month: number, year: number) =>
  `${basePath}/holiday/${month}/${year}`;

export const getTimeCheckingMonthUrl = (screenCode: string) =>
  `${basePath}/${screenCode}/time-keeping-month/statistic`;

export const getListFeedbackManagerUrl = (screenCode: string) =>
  `${basePath}/${screenCode}/manage/explain`;

export const getListFeedbackUrl = (screenCode: string) =>
  `${basePath}/${screenCode}/explain`;

export const getFeedbackDetailUrl = (screenCode: string, id: string) =>
  `${basePath}/${screenCode}/explain/${id}`;
